import { useScroll } from "framer-motion";
import { useRef, useState, useEffect, type FC } from "react";
import useEmblaCarousel from "embla-carousel-react";
import { type EmblaCarouselType } from "embla-carousel";
import { Heading } from "@tennr/frontend/components/Heading/Heading";
import { Testimonial } from "@tennr/frontend/components/Testimonial/Testimonial";

import "./TestimonialsSection.css";

export const TestimonialsSection: FC = (props) => {
  
  const sectionRef = useRef<HTMLDivElement>(null);

  const [emblaRef, emblaApi] = useEmblaCarousel({
    loop: true,
    containScroll: false,
    align: "start",
  });
  
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [slidesInView, setSlidesInView] = useState<number[]>([]);
  const [selectedIndex, setSelectedIndex] = useState(0);

  const scrollTo = (index: number) => {
    if (emblaApi) emblaApi.scrollTo(index);
  };

  useEffect(() => {
    if (!emblaApi) return;

    const updateSlidesInView = (emblaApi: EmblaCarouselType): void => {
      setSlidesInView(emblaApi.slidesInView());
      setSelectedIndex(emblaApi.selectedScrollSnap()); // 👈 Add this
    };

    updateSlidesInView(emblaApi);
    emblaApi.on("slidesInView", updateSlidesInView);
    emblaApi.on("reInit", updateSlidesInView);
    emblaApi.on("select", updateSlidesInView); // 👈 Also listen for slide selection
  }, [emblaApi]);

  // add standard Framer Motion scroll tracking for opacity animation
  useScroll({
    target: sectionRef,
    offset: ["start 100vh", "start start"],
  });

  // transform scroll progress to opacity values:
  // 0 to 0.5 scrollYProgress => 0 to 1 opacity
  // 0.5 to 1 scrollYProgress => 1 to 0 opacity

  

  return (
    <section className="testimonials-section" ref={sectionRef} data-tracker-id="testimonials-section">
      <img src="/img/testimonial-rectangles.3.svg" alt="" className="static-rectangles" />
      <Heading
        
        title="Testimonials"
        heading="What our customers say"
        body="They're improving quality, moving faster, and freeing up their teams. Here's what they have to say:"
        color="dark"
        variant="section"
        width={560}
        wrapHeading="balance"
        {...(props?.heading ?? {})}
      />
      <div className="testimonials-carousel" ref={emblaRef}>
        <div className="testimonials-carousel-slides">
          {props.testimonials.map(({ quote, image, attributedTo, attributedToTitle }, i) => {
            return (
              <div key={i} className="testimonials-carousel-slide" onClick={() => scrollTo(i)}>
                <Testimonial
                  key={i}
                  quote={quote}
                  image={image}
                  attributedTo={attributedTo}
                  attributedToTitle={attributedToTitle}
                />
              </div>
            );
          })}
        </div>
      </div>
      <div className="carousel-dots-left">
        {props.testimonials.map((_, index) => (
          <button
            key={index}
            className={`carousel-dot ${selectedIndex === index ? "active" : ""}`}
            onClick={() => scrollTo(index)}
          />
        ))}
      </div>
    </section>
  );
};
